let address = {
    "广州南站":["广州南站","G3324","gznz.png",113.275824,22.994826],
    "广州站":["广州站","G3222","gzz.png",113.264437,23.154981],
    "广州东站":["广州东站","G3241","gzdz.png",113.331062,23.155823],
    "白云机场":["白云机场","59284","byjc.png",113.314282,23.395352],
    "广州北站":["广州北站","G3241","gzbz.png",113.331062,23.155823],
    "南沙客运港":["南沙客运港","59284","nskyg.png",113.314282,23.395352],
};

export {
    address
}